const styles = (theme) => ({
  root: {},
  icon: {
    background: theme.palette.background.lighter,
    color: theme.palette.custom.wellbeing,
    marginTop: 0,
  },
  cardContent: {
    padding: 0,
  },
  image: {
    width: '100%',
  },
  buttonContainer: {
    marginBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  divider: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    [theme.breakpoints.up('md')]: {
      margin: `0 ${theme.spacing.unit * 3}px`,
    },
  },
  contentContainer: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px 0`,
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px 0`,
    },
  },
  buttonsRight: {
    textAlign: 'right',
  },
});

export default styles;
